module.exports = __webpack_public_path__ + "static-v-shop/1786468182979/img/data-fiscal.a3ed015d.png";